import L from '../../leaflet/leaflet-plugins-loader';
import { INgsiIdDesignPattern } from '../helpers/ngsild.constants'
import { IMapWidgetFormGroupSettings } from '../../../map-widget-settings/map-widget-settings.interface'
import { PopupService } from '../../leaflet/popup/popup.service'
import { TooltipService } from '../../leaflet/tooltips/tooltip.service'
import { ILeafletInstance } from '../../leaflet/leaflet.interface'
import { MarkerService } from '../../leaflet/markers/marker.service'
import { INgsiRadarTarget } from '../interfaces/ngsi-radar-target.interface'
import * as AisTrackSymbol from '../../leaflet/markers/leaflet-tracksymbol2/ais-track-symbol'
import { TrackerDetails } from '../../leaflet/markers/leaflet-tracksymbol2/ais-track-symbol'
import { IMapWidgetPermissions } from '../../../../shared/interfaces/map-widget-permission.interface'
import { INgsiEntity } from '../interfaces/ngsi-entity.interface'
import { INotification } from 'ngsild-connector'
import * as DivIcons from '../../leaflet/markers/div-icons/div-icons-constant'
import { INgsiAIS } from '../interfaces/ngsi-ais.interface'


export const entityType: string = `RadarTarget`
export const radarTargetsOwner: string = 'CAPTN'

export const ngsiRadarTargetsIdPattern: Omit<INgsiIdDesignPattern, 'idPattern'> = {
    prefix: `urn:ngsi-ld:`,
    type: entityType,
    owner: radarTargetsOwner
}

export const allowDisplayOfEntity = (
    settings: IMapWidgetFormGroupSettings,
    entity: INgsiEntity
): boolean => {
    return entity.type === entityType && settings.enableRadarTarget;
}

export const grantEntityPassage = (
    notification: INotification,
    appPluginWidgetSettings: IMapWidgetFormGroupSettings,
    widgetPermissions: IMapWidgetPermissions
): boolean => {
    const settings = appPluginWidgetSettings
    if (settings?.entities) {
        return widgetPermissions.radarTargetDataEnabled &&
            allowDisplayOfEntity(settings, notification.data[0]);
    } else {
        return false;
    }
}

export function createMarker(
    entity: INgsiRadarTarget,
    settings: IMapWidgetFormGroupSettings,
    instance: ILeafletInstance,
    popupService: PopupService,
    tooltipService: TooltipService,
    markerService: MarkerService
) {
    entity.shipType = 104;

    const marker = L.marker(
        [entity.location.coordinates[1], entity.location.coordinates[0]],
        {  icon: DivIcons.squareIcon('#DA4167') }
    );

    const positionReport= AisTrackSymbol.setAISPositionReport(<INgsiAIS><unknown>entity);
    const options = AisTrackSymbol.setAISReportOptions(<INgsiAIS><unknown>entity);

    const trackerDetails: TrackerDetails = {
        marker: marker,
        positionReport: positionReport,
        options: options
    }

    if (trackerDetails.marker) {
        popupService.bindPopupOnce(trackerDetails.marker, entity, settings, instance, popupService, trackerDetails)
    }

    return trackerDetails?.marker;
}

export function updateMarker(
    entity: INgsiRadarTarget,
    marker: L.Marker<any>,
    settings: IMapWidgetFormGroupSettings,
    instance: ILeafletInstance,
    popupService: PopupService,
    tooltipService: TooltipService,
    markerService: MarkerService
) {
    const positionReport= AisTrackSymbol.setAISPositionReport(<INgsiAIS><unknown>entity);
    const options = AisTrackSymbol.setAISReportOptions(<INgsiAIS><unknown>entity);

    marker.setLatLng([entity.location.coordinates[1], entity.location.coordinates[0]])

    const trackerDetails: TrackerDetails = {
        marker: marker,
        positionReport: positionReport,
        options: options
    }

    instance.additionalEntities.set(entity.id, entity);
    instance.markers.set(entity.id, marker);

    if (trackerDetails.marker) {
        popupService.bindPopupOnce(trackerDetails.marker, entity, settings, instance, popupService, trackerDetails)
    }

    return trackerDetails.marker;
}
